import { powerUpCommonStrings } from "@vendata/power-up-clients-common/strings";
import { auth_strings } from "@saflib/ory-kratos-spa/strings";

export const authAppStrings = {
  ...powerUpCommonStrings,
  ...auth_strings,
  // Any customized pages with their own strings should be added here
};
